import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import _ from 'lodash';
import Loader from '../../../common/Loader';
import Item from './item';
import Alphabeth from './alphabeth_button';
import Signature from './signature';
import Roster from './roster_popup';
import { Link } from 'react-router';
import SignatureModal from '../../../common/modals/Signature';
import './css.css';
import EmptyPayload from '../../../EmptyPayload';

class Comp extends React.Component {

  state = {
    bootstrapped: false,
    searchText: null, signing: false, selectedTeam: null,
    fixingRoster: false,
    letter: 'A',
    showingSignature: false,
  }

  // Lifecycle
  componentWillMount() {
    const { setTitle, params } = this.props, { idSeason, letter } = params;
    setTitle && setTitle({
      sub: 'SHIRTS',
      main: this.props.season.Name || null
    });
    this.props.fetchSizes && this.props.fetchSizes();
    this.props.fetchSeason && this.props.fetchSeason(idSeason);
    this.props.seasonActions && this.props.seasonActions.fetchShirtsSignature(idSeason, letter);
  }
  componentWillReceiveProps = (nextProps) => {
    // The sequence of this is always tricky

    if (nextProps.season !== this.props.season) {
      const { setTitle } = nextProps;
      setTitle && setTitle({
        sub: 'SHIRTS',
        main: nextProps.season.Name || null
      });
    }

    if (nextProps.params.letter !== this.props.params.letter) {
      const { params: { idSeason, letter } } = nextProps;
      this.props.seasonActions && this.props.seasonActions.fetchShirtsSignature(idSeason, letter);
    }
  }
  componentWillUnmount = () => {
    this.props.seasonActions && this.props.seasonActions.clearSignatures();
  }
  //

  handleSearch = (e) => {
    this.setState({ searchText: e.target.value });
  }
  clearSearch = () => {
    this.txtSearch.value = null;
    this.setState({ searchText: null });
  }

  // Signature
  sign = (selectedTeam) => this.setState({ selectedTeam, signing: true });
  fnShowSignature = (selectedTeam) => this.setState({ selectedTeam, showingSignature: true });

  doSign = (signature, coach) => {

    const { selectedTeam } = this.state, { teams } = this.props;
    const team = _.find(teams, t => t.IdTeam === selectedTeam.IdTeam);
    team.UserName_CoachSigned = coach.UserName;
    team.Signature = signature;
    this.props.teamActions && this.props.teamActions.updateUniformSwag({
      idTeamDivision: team.IdTeamDivision,
      signature,
      idCoach: coach.IdCoach,
      idUniformCoachSignature: team.IdUniformCoachSignature
    });
    this.setState({ teams, selectedTeam: null, signing: false });

  }
  toggleSigning = () => this.setState({ signing: !this.state.signing });
  toggleShowingSignature = () => this.setState({ showingSignature: !this.state.showingSignature });
  //

  fnSelectRoster = selectedTeam => this.setState({ fixingRoster: true, selectedTeam });
  toggleFixRoster = () => this.setState({ fixingRoster: !this.state.fixingRoster });


  render() {
    const { bootstrapped, searchText, signing, selectedTeam, fixingRoster, showingSignature } = this.state,
      { params: { letter }, season: { IdSeason }, teams } = this.props;

    // TODO: this is IOC
    let filteredTeams = _.chain(teams)
      .filter(team => {
        if (letter === 'ALL') return true;
        return team.TeamName.charAt(0) === letter;
      })
      .filter(team => {
        if (searchText) {
          return team.TeamName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 || (team.IdTeam + '').indexOf(searchText.toLowerCase()) !== -1;
        }
        return true;
      })
      .sortBy('TeamName')
      .value();

    return <section id="shirts" className="p-2 bg-gray-dark">
      {true && <div className="filters-wrapper d-flex flex-row white">
        <div className="form-group align-self-center margin-top">
          <Alphabeth letter={letter} alpha='A' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='B' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='C' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='D' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='E' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='F' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='G' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='H' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='I' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='J' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='K' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='L' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='M' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='N' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='O' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='P' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='Q' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='R' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='S' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='T' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='U' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='V' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='W' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='X' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='Y' idSeason={IdSeason} />
          <Alphabeth letter={letter} alpha='Z' idSeason={IdSeason} />
          <Link className={`btn btn-${letter === 'ALL' ? 'info' : 'link'} btn-sm`} to={`/season/${IdSeason}/shirts/ALL`}>ALL</Link>
        </div>
        {/* Right */}
        < div className="d-flex flex-row ml-auto">
          <div className="input-group align-self-center">
            <div className="input-group-prepend">
              <span className="input-group-text"><i className="fa fa-search" /></span>
            </div>
            <input ref={(i) => this.txtSearch = i} type="text" className="form-control" placeholder="Search" onChange={this.handleSearch} />
            <div className="input-group-append" onClick={this.clearSearch}>
              <span className="input-group-text"><i className="fa fa-times" /></span>
            </div>
          </div>
        </div>
      </div>}
      <ReactCSSTransitionGroup className="work-area " transitionName="example" transitionAppear={true} transitionAppearTimeout={500}
        transitionEnterTimeout={500} transitionEnter={true} transitionLeave={false}>

        <div key="with-data" className=" d-flex align-items-stretch full-height">
          <table style={{ borderBottom: '1px solid white' }} className="table table-sm w-100 font-10">
            <thead className="bg-info white">
              <tr>
                <th>Name</th>
                <th>Division</th>
                <th>Coaches</th>
                <th>Players</th>
                {/*<th>Roster Shirt Size</th>*/}
                <th>Total</th>
                <th>Signature</th>
              </tr>
            </thead>
            <tbody className="white">
              {filteredTeams.map((team, i) => <Item team={team} key={team.IdTeam} fnSign={this.sign} fnShowSignature={this.fnShowSignature}
                fnSelectRoster={this.fnSelectRoster} sizes={[...this.props.sizes]} />)}
            </tbody>
          </table>
        </div>

        {!bootstrapped && false && <Loader key="loader" message={`Loading Season Assets`} />}
        {bootstrapped && false && <EmptyPayload message="Currently there are no Games Scheduled" />}
      </ReactCSSTransitionGroup>
      {signing && <Signature team={selectedTeam} isOpen={signing} toggle={this.toggleSigning} doSign={this.doSign} />}
      {showingSignature && <SignatureModal shirts={true} team={selectedTeam} isOpen={showingSignature} toggle={this.toggleShowingSignature} />}
      {fixingRoster && selectedTeam && <Roster team={selectedTeam} sizes={this.props.sizes}
        isOpen={fixingRoster} toggle={this.toggleFixRoster} rosterActions={this.props.rosterActions} />}
    </section>
  }
}

export default Comp;
